import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, FormGroup } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { isRequired, validateEndDate } from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';
import FormFooter from '../../../common/forms/FormFooter';
import DatePicker from '../../../common/forms/input/DatePicker';
import Loader from '../../../common/Loader';

const validateDate = (value, allValues) =>
  validateEndDate(value, allValues.fromDateString);

export const BillReportDetailForm = ({ handleSubmit, loading }) =>
  loading ? (
    <Loader />
  ) : (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Desde" required>
          <Field
            name="fromDateString"
            component={DatePicker}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="Hasta" required>
          <Field
            name="toDateString"
            component={DatePicker}
            validate={[isRequired, validateDate]}
          />
        </FormItem>
      </FormGroup>

      <FormFooter />
    </Form>
  );

const mapStateToProps = ({ AccountingUnit }) => ({
  loading: !AccountingUnit.Billing.getIn([
    'detail',
    'current',
    'activity',
  ]).isEmpty(),
});

BillReportDetailForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

BillReportDetailForm.defaultProps = {
  loading: false,
};

const formComponent = reduxForm({
  form: 'BillReportDetailForm',
})(BillReportDetailForm);

export default connect(mapStateToProps)(formComponent);
